import Vue from 'vue'
import VueComponent from './GlobalHeader.vue'

new Vue({
  render: h => h(VueComponent),
}).$mount('#vue-component-globalHeader')